import { View, Image, useWindowDimensions, ScrollView } from "react-native";
import RenderHTML from "react-native-render-html";
import { customStyles } from "../../theme/styles"
import React from 'react'

const HowItWorks = (props:any) => {
    let data = props.data
    const { width } = useWindowDimensions()


    let tagStyle = {


        ul: {
            color: '#3BAA90',
        },
        li: {
            marginBottom: 10,
            color: 'black'
        }
    }
  return (
    <View style={customStyles.htmlContainer}>
            <Image style={customStyles.infoImagesStyle} source={require("../../assets/how_it_works.png")} />

            <ScrollView contentInsetAdjustmentBehavior="automatic" >
                <View style={customStyles.htmlContent}>
                    <RenderHTML tagsStyles={tagStyle} contentWidth={width} source={{ html: data["how_it_works"] }} />
                </View>
            </ScrollView>
        </View>
  )
}



export default HowItWorks

